module.exports = __webpack_public_path__ + "img/card-bg-deco-no-value.a46a9213.png";